import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const FARMERS_BG = "/images/farmer-delivery.jpeg";

export default function FarmersSection({ onEnquire }) {
  const { t } = useLanguage();
  return (
    <section
      data-testid="farmers-section"
      className="py-16 lg:py-24 relative overflow-hidden"
      style={{ backgroundColor: '#0A3F22' }}
    >
      <div className="absolute inset-0 opacity-10"
        style={{ backgroundImage: `url(${FARMERS_BG})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      />
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider mb-4"
              style={{ backgroundColor: 'rgba(217,119,6,0.2)', color: '#FCD34D', border: '1px solid rgba(217,119,6,0.4)' }}>
              {t.farmers.badge}
            </span>
            <h2 className="font-heading font-black text-3xl sm:text-4xl text-white leading-tight mb-2">
              {t.farmers.title}
            </h2>
            <h2 className="font-heading font-black text-3xl sm:text-4xl leading-tight mb-4" style={{ color: '#FCD34D' }}>
              {t.farmers.title2}
            </h2>
            <p className="text-lg font-semibold text-white/80 mb-4">{t.farmers.subtitle}</p>
            <p className="text-sm leading-relaxed mb-8" style={{ color: '#A4C8AF' }}>{t.farmers.description}</p>

            <ul className="space-y-3 mb-8">
              {t.farmers.benefits.map((b, i) => (
                <motion.li
                  key={b}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 }}
                  className="flex items-start gap-3"
                >
                  <CheckCircle size={18} className="flex-shrink-0 mt-0.5" style={{ color: '#FCD34D' }} />
                  <span className="text-sm font-medium" style={{ color: '#CDDFD2' }}>{b}</span>
                </motion.li>
              ))}
            </ul>

            <button
              data-testid="farmers-cta"
              onClick={onEnquire}
              className="px-8 py-4 rounded-lg font-heading font-bold text-white text-base transition-all duration-300 hover:scale-105"
              style={{ backgroundColor: '#D97706', boxShadow: '0 4px 20px rgba(217,119,6,0.4)' }}
            >
              {t.farmers.cta} →
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="hidden lg:block"
          >
            <div className="rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]"
              style={{ backgroundImage: `url(${FARMERS_BG})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
